import type { PortalWording } from "@shared-core/domain/portal-sign-in/types";

// Mock-up phase (docs/features/portal-sign-in, 09 5.8): the new sign-in routes sit beside the existing sign-in pages
// under /preview-sign-in/..., because /sign-in and the rest are still the External ID pages. When
// the screens are productionised the routes move to /sign-in, /invite/:token, /choose, /signed-out and /account and
// this folder goes.

export const PREVIEW_BASE = "/preview-sign-in";

export const previewPaths = {
  signIn: (): string => PREVIEW_BASE,
  /** A mock invite token: `invite-pete`. */
  invite: (token: string): string => `${PREVIEW_BASE}/invite/${token}`,
  choose: (): string => `${PREVIEW_BASE}/choose`,
  signedOut: (everywhere = false): string =>
    `${PREVIEW_BASE}/signed-out${everywhere ? "?everywhere=1" : ""}`,
  account: (): string => `${PREVIEW_BASE}/account`,
  home: (): string => `${PREVIEW_BASE}/home`,
};

/** The supplier portal's words for the shared screens. */
export const SUPPLIER_WORDING: PortalWording = {
  company: "Pollards",
  brand: "Pollards supplier portal",
  tagline: "Your orders and quote requests",
  partyNoun: "supplier",
  records: "orders and quote requests",
  appName: "Pollards portal",
  phone: "01752 663111",
};

/** How each portal is named in a sentence, for the Account page. */
export const PORTAL_NAMES = {
  customer: "customer portal",
  supplier: "supplier portal",
} as const;
